import { getArticleImageLinks, getImageArticles, getTextArticles } from "../../api/articles";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Article from "../../components/Article/article";
import "./style.css";

const CARDINAL = "#B83E26";

const tabButtonStyle = (active) => ({
  padding: "12px 32px",
  border: "none",
  borderBottom: active ? `3px solid ${CARDINAL}` : "3px solid transparent",
  backgroundColor: "transparent",
  color: active ? CARDINAL : "#666",
  fontWeight: active ? 700 : 600,
  cursor: "pointer",
  fontSize: "18px",
  transition: "all 0.3s ease",
  position: "relative",
});

function Articles() {
  const [activeTab, setActiveTab] = useState("image");
  const [imageArticles, setImageArticles] = useState([]);
  const [textArticles, setTextArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchArticles() {
      try {
        const [imageArticlesData, textArticlesData] = await Promise.all([
          getImageArticles(10),
          getTextArticles(10)
        ]);

        const imageArticlesWithLinks = await Promise.all(
          imageArticlesData.map(async (article) => {
            const imageLinks = await getArticleImageLinks(article.article_id);
            return {
              articleId: article.article_id,
              articleTitle: article.article_title,
              articleDescription: article.article_description,
              articleDate: article.article_date,
              imageLinks,
            };
          })
        );

        const textArticlesFormatted = textArticlesData.map((article) => {
          // Get first text block for preview
          const firstTextBlock = article.text_article_block
            ?.sort((a, b) => a.ordinal - b.ordinal)
            .find(block => block.content?.trim());
          
          const contentPreview = firstTextBlock?.content
            ?.replace(/<[^>]*>/g, '') // Strip HTML tags
            .substring(0, 200) || "";
          
          return {
            articleId: article.article_id,
            articleTitle: article.article_title,
            articleDescription: article.article_description,
            articleDate: article.article_date,
            contentPreview,
          };
        });

        setImageArticles(imageArticlesWithLinks);
        setTextArticles(textArticlesFormatted);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchArticles();
  }, []);

  if (loading) return <p style={{ padding: "48px 24px", textAlign: "center" }}>Loading ...</p>;
  if (error) return <p style={{ padding: "48px 24px", textAlign: "center", color: "#d32f2f" }}>Error: {error}</p>;

  const currentArticles = activeTab === "image" ? imageArticles : textArticles;

  return (
    <div className="articles-page">
      <div className="articles-inner">
        <div style={{ 
          display: "flex", 
          gap: "48px", 
          marginTop: "48px",
          marginBottom: "48px", 
          justifyContent: "center",
          borderBottom: "1px solid #e0e0e0"
        }}>
          <button
            type="button"
            style={tabButtonStyle(activeTab === "image")}
            onClick={() => setActiveTab("image")}
          >
            Image Articles
          </button>
          <button
            type="button"
            style={tabButtonStyle(activeTab === "text")}
            onClick={() => setActiveTab("text")}
          >
            Text Articles
          </button>
        </div>

        <div className="articles-list">
          {activeTab === "image" ? (
            imageArticles.length === 0 ? (
              <p style={{ textAlign: "center", color: "#666" }}>No image articles yet . . .</p>
            ) : (
              imageArticles.map((article) => (
                <Article
                  key={article.articleId}
                  articleTitle={article.articleTitle}
                  articleDescription={article.articleDescription}
                  imageLinks={article.imageLinks}
                />
              ))
            )
          ) : (
            textArticles.length === 0 ? (
              <p style={{ textAlign: "center", color: "#666" }}>No text articles yet . . .</p>
            ) : (
              textArticles.map((article) => (
                <div key={article.articleId} className="text-article-card">
                  <h4 className="text-article-title">{article.articleTitle}</h4>
                  <p className="text-article-description">{article.articleDescription}</p>
                  <p className="text-article-preview">
                    {article.contentPreview}{article.contentPreview.length >= 200 ? "..." : ""}
                  </p>
                  <Link to={`/article/${article.articleId}`} className="text-article-link">
                    Read Full Article →
                  </Link>
                  <div className="article-divider" aria-hidden="true"></div>
                </div>
              ))
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default Articles;
